import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'mj-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardHeaderComponent {
  @Input() title: string;
  /**
   * @desc you can use stuff like 'square_sand', 'triangle_sand' here, just like file names in assets/svgs/spice folder
   */
  @Input() spice?: string = '';
}
